import { BaseVO, StreamId, streamId } from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";
import { mixerId } from "../../schema";
import { MixerId } from "../../interface";

export class MixerExitVO extends BaseVO<MixerExit> {
  private static validation = JsonSchemaValidator.compile(
    MixerExitVO.validationSchema()
  );

  constructor(value: MixerExit) {
    super(JsonSchemaValidator.assert(MixerExitVO.validation, value));
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["mixerId", "streamId"],
      properties: {
        mixerId,
        streamId
      },
      additionalProperties: false
    };
  }
}

interface MixerExit {
  mixerId: MixerId;
  streamId: StreamId;
}
